import { localeStore } from '@/shared/i18n/locale-store';
import type { Locale } from '@/shared/i18n/locales';

/** Money is stored as integer cents of EUR so totals never drift; the locale only formats it. */
export function formatCents(cents: number | undefined | null, locale: Locale = localeStore.read()): string {
  if (cents == null) return '—';
  return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(cents / 100);
}
